const formValidationRules = {
  mandatory: (v: any) => isEmpty(v) || 'Campo obrigatório',
  email: (v: any) => {
    // Check if the field is a valid email using a regex
    const expRegEmail = /^[a-z0-9._]+@[a-z0-9]+\.[a-z]+(\.([a-z]+))?$/i;
    return expRegEmail.test(v) || 'Email inválido';
  },
  number: (v: any) => !isNaN(v) || 'Valor Inserido não é um número.',
  integer: (v: any) => Number.isInteger(Number(v)) || 'Valor Inserido não é um número inteiro.',
};

const isEmpty = (value: any): boolean => !!value || value === '0';

export default formValidationRules;
